// External libraries
import React from 'react';
import { func } from 'prop-types';
import { FullName } from '@checkout/react-components';
import { useStoreState } from 'easy-peasy';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

const Name = props => {
  useMountLogging('Name');
  const firstName = useStoreState(({ form }) => form.firstName);
  const lastName = useStoreState(({ form }) => form.lastName);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);

  return (
    <FullName
      disabled={isFormSubmitting}
      firstName={firstName}
      labels={{
        firstName: getContent('fieldLabels.firstName'),
        lastName: getContent('fieldLabels.lastName'),
      }}
      lastName={lastName}
      {...props}
    />
  );
};

Name.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { Name };
